/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from "react";
import Button from 'react-bootstrap/Button'

// style imports
import './SupportView.scss';

/**
 * this page is used to show the support details
 * 
 * @param props
 * 
 * @return Support html
 * 
**/

export class SupportView extends Component {

    openLink = () => {
        window.open("https://ctbids.atlassian.net/servicedesk/customer/portal/1", "_blank")
    }

    render() {
        return (
            <div className="main-div">
                <div className="d-flex justify-content-center">
                    <div className="d-flex flex-column mb-3">
                        <div className="p-2 support-header">
                            <h3>
                                Welcome to support we are happy to help you
                            </h3>
                        </div>
                        <div className="d-flex justify-content-center">
                            <div className="support-content">
                                <img src={`${process.env.PUBLIC_URL}/static/images/Support.svg`} alt="support" />
                                <div className="p-2">
                                    Get in touch with our customer support team
                                </div>
                                <div>
                                    <Button variant="success" onClick={() => this.openLink()}>
                                        Click here to raise your support request
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}